import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./FinanceReport.styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const FinanceReport = ({ page } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Item>This is {page} component</Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default FinanceReport;
